import styled from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Content = styled.div`
  margin-top: 24px;
  display: grid;
  gap: 16px;

  ${media.greaterThan('medium')`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${media.greaterThan('huge')`
    max-width: 80%;
    gap: 24px;
  `}
`

export const CrmContainer = styled.div`
  margin-top: 8px;

  ${media.greaterThan('huge')`
    max-width: 80%;
    margin-top: 16px;
  `}
`

export const AddCrm = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  ${media.greaterThan('huge')`
    gap: 24px;
  `}
`

export const CrmList = styled.div`
  /* padding: 20px 0; */
`

export const DeleteButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 0;
`
